/* eslint-disable no-template-curly-in-string */
import Router, { Resource } from 'tg-resources';

import reverseUrl from 'utils/urls';
import { getCookie } from 'utils/cookie';

export const apiConfig = {
    headers: () => ({
        Accept: 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),

        // Django detects ajax request with X-Requested-With == XMLHttpRequest
        // So pass this with other headers
        'X-Requested-With': 'XMLHttpRequest',
    }),
};

const api = new Router(
    {
        arena: new Resource(reverseUrl('mediacache-list')),
        members: new Resource(reverseUrl('member-list')),
        projects: new Resource(reverseUrl('proj-list')),
        projectMedia: new Resource(reverseUrl('project_media-detail', '${pk}')),
        mentors: new Resource(reverseUrl('consultant-list')),
        news: new Resource(reverseUrl('news-list')),
        favourites: new Resource(reverseUrl('favourites_for_current_user')),
        toggleFavourite: new Resource(reverseUrl('toggle_favourite_for_current_user', '${mediaCacheId}')),
        mediaUploadPrivate: new Resource(reverseUrl('trafo_arena_rest_mediaupload', { privacy: 'private' })),
        mediaPreviewDetail: new Resource(reverseUrl('trafo_arena_rest_mediapreview', '${pk}')),
        mediaDelete: new Resource(reverseUrl('trafo_arena_media_delete', '${pk}')),
        commentsForItem: new Resource(reverseUrl('comments-for-item', '${model}', '${pk}')),
        commentsPublic: new Resource(reverseUrl('comments-public')),
        commentsGuestMentor: new Resource(reverseUrl('comments-guestmentor')),
        commentDetail: new Resource(reverseUrl('comments-detail', '${pk}')),
    },
    {
        ...apiConfig,
        apiRoot: DJ_CONST.SITE_URL,
    },
);

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js